import React, {useState, useEffect, useRef} from "react";
import {useObserver} from "mobx-react-lite";

import {useFetch} from "../../hooks/useFetch";
import {useStore} from "../../hooks/useStore";
import {CourierMapTab} from "./CourierMapTab/CourierMapTab";
import useIsFocused from "../../hooks/useIsFocused";

export const DashboardPage = () => {
    const isFocused = useIsFocused();

    const [recall, setRecall] = useState(true);

    const recallRef = useRef(recall);
    recallRef.current = recall;

    useEffect(() => {
        if (isFocused) {
            let timeout = null;

            timeout = setTimeout(async () => {
                await setRecall(!recallRef.current);
            }, 2000);

            return () => clearTimeout(timeout);
        }
    }, [recall, isFocused]);

    return useObserver(() => <CourierMapTab isFocused={isFocused} recall={recall} />);
};
